// extracted by mini-css-extract-plugin
export var label = "_gt-2";
export var slideContainer = "_gt-0";
export var slider = "_gt-1";